export const TRACKER_TYPES = {
    SCRIPT: "script",
    IMG: "img",
    IFRAME: "iframe"
};
